import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useQueryClient} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {mutations} from '@refra/api/mutations'
import {useRefraMutation} from '@refra/modules/common/hooks'
import {logger} from '@refra/modules/common/utils'

export const useAddStaticPartDocuments = () => {
  const {t} = useTranslation()
  const queryClient = useQueryClient()

  return useRefraMutation({
    mutationFn: mutations.addStaticPartDocuments,
    onError: (error) => {
      const errorDetails = error?.response?.data.detail ?? error.message ?? error.response?.status
      logger
        .context('useAddStaticPartDocuments')
        .extras({errorDetails})
        .error('Error occurred while adding static part attachment')

      spawnErrorToast(t('error.addStaticPartDocuments'))
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: ['staticPartDocuments']})
      await queryClient.invalidateQueries({queryKey: ['attachedDocumentsFiles']})
      spawnSuccessToast(t('success.addStaticPartDocuments'))
    }
  })
}
